import apiRequest from './apiRequest';
export default async function deleteCharacter(characterID: string) {
  return await apiRequest('mogen-orchestration', `/characters/${characterID}`, {
    method: 'DELETE',
  });
}